import {
    SIGNUP_SUCCESS,
    SIGNUP_FAIL,
    ACTIVATION_SUCCESS,
    ACTIVATION_FAIL,
    SET_AUTH_LOADING,
    REMOVE_AUTH_LOADING,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    REFRESH_SUCCESS,
    REFRESH_FAIL,
    LOGOUT,

} from './types'
import axios from 'axios'



//FUNCION QUE NOS PERMITE REGISTRARNOS CON REDUX USANDO EL ENDOPOINT DE JWT
//USANDO AXIOS VAMOS A LLAMAR A LA API ENPOINT JWT
//USAMOS HEADER Y CONTENT-TYPE IGUAL QUE POSTMAN
export const signup = (first_name, last_name, email, phone, password, re_password) => async dispatch => {
    //APENAS LE DAMOS CLICK EN EL BOTON, VAMOS ALTIRO A CARGAR.
    dispatch({
        type: SET_AUTH_LOADING,
    });
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        first_name,
        last_name,
        email,
        phone,
        password,
        re_password
    });

    //YA CONFIGURADO, REALIZAMOS EL LLAMADO.
    try {
        //ESTA VARIABLE ESTA CONFIGURADA EN .ENV
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/`, body, config);

        if (res.status === 201) {
            dispatch({
                type: SIGNUP_SUCCESS,
                payload: res.data
            });
            dispatch('Te enviamos un correo, por favor activa tu cuenta. Revisa el correo de spam')
        } else {
            dispatch({
                type: SIGNUP_FAIL
            });
            dispatch('Error en crear la cuenta, intente nuevamente')
        }
        //SI VA TODO BIEN O MAL, HAY QUE TERMINAR DE CARGAR
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
    } catch (err) {
        dispatch({
            type: SIGNUP_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        dispatch('Error conectando con el servidor, intenta mas tarde.');
    }
};

export const activate = (uid, token) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING,
    });
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        uid,
        token
    });
    try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/activation/`, body, config);
        if (res.status === 204) {
            dispatch({
                type: ACTIVATION_SUCCESS,
            });

            dispatch('Activacion correcta.');
        } else {
            dispatch({
                type: ACTIVATION_FAIL
            });
            dispatch('Activacion erronea.');
        }
        dispatch({
            type: REMOVE_AUTH_LOADING
        });

    } catch (err) {
        dispatch({
            type: ACTIVATION_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        dispatch('El servidor no ha activado la cuenta.');

    }
}

export const login = (email, password) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING
    });

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        email,
        password
    });
    try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/create/`, body, config);
        if (res.status === 200) {
            dispatch({
                type: LOGIN_SUCCESS,
                payload: res.data
            });
            dispatch(load_user());
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
            return { success: true };
        } else {
            dispatch({
                type: LOGIN_FAIL
            });
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
            return { success: false };
        }
    }
    catch (err) {
        dispatch({
            type: LOGIN_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        return { success: false };
    }
}
export const forgotPassword = (email) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = {
        email: email
    };

    try {
        const res = await axios.patch(`${process.env.REACT_APP_API_URL}/lost-password/`, body, config);
        if (res.status === 200) {
            return { success: true };
        } else {
            return { success: false };
        }
    }
    catch (err) {
        return { success: false };
    }
}
export const passwordChange = (id, password, passwordNew, passwordValidate) => async dispatch => {
    if (localStorage.getItem('access')) {
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
            }
        };

        const body = {
            id: id,
            password: password,
            passwordNew: passwordNew,
            passwordValidate: passwordValidate
        };

        try {
            const res = await axios.patch(`${process.env.REACT_APP_API_URL}/change-password/`, body, config);
            if (res.status === 200) {
                return { success: true };
            } else {
                return { success: false };
            }
        }
        catch (err) {
            return { success: false };
        }
    }
}
export const load_user = () => async dispatch => {
    if (localStorage.getItem('access')) {
        const config = {
            headers: {
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        };

        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/users/me/`, config);

            if (res.status === 200) {
                dispatch({
                    type: USER_LOADED_SUCCESS,
                    payload: res.data
                });
            } else {
                dispatch({
                    type: USER_LOADED_FAIL
                });
            }
        }
        catch (err) {
            dispatch({
                type: USER_LOADED_FAIL
            });
        }
    } else {
        dispatch({
            type: USER_LOADED_FAIL
        });
    }
}


//ESTA FUNCION ME PERMITE TENER LA INICIAR INCIADA AL REFRESCAR LA PAGINA, QUE SON UTILIZADAS EN EN LAYOUT
export const check_authenticated = () => async dispatch => {
    if (localStorage.getItem('access')) {
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const body = JSON.stringify({
            token: localStorage.getItem('access')
        });

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/verify/`, body, config);

            if (res.status === 200) {
                dispatch({
                    type: AUTHENTICATED_SUCCESS
                });
            } else {
                dispatch({
                    type: AUTHENTICATED_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: AUTHENTICATED_FAIL
            });
        }
    } else {
        dispatch({
            type: AUTHENTICATED_FAIL
        });
    }
}

//ESTA FUNCION ME PERMITE TENER LA SESION INCIADA AL REFRESCAR LA PAGINA, QUE SON UTILIZADAS EN EN LAYOUT
//AL ENTREGARLE EL TOKEN DE REFRESH, ESTE ME OTORGA UN NUEVO TOKEN DE ACCESS
export const refresh = () => async dispatch => {
    if (localStorage.getItem('refresh')) {
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const body = JSON.stringify({
            refresh: localStorage.getItem('refresh')
        });

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/refresh/`, body, config);

            if (res.status === 200) {

                dispatch({
                    type: REFRESH_SUCCESS,
                    payload: res.data
                });
            } else {
                dispatch({
                    type: REFRESH_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: REFRESH_FAIL
            });
        }
    } else {
        dispatch({
            type: REFRESH_FAIL
        });
    }
}


export const logout = () => dispatch => {
    dispatch({
        type: LOGOUT
    });
    //dispatch('Cierre de sesion correcto');
}



